export default __webpack_public_path__ + "static/media/Digital_Info_App_Icon.fdf5384d.svg";